import React, { VFC } from 'react'
import { NewTicketUi } from './NewTicket.ui'

export const NewTicket: VFC = () => {
  return <NewTicketUi />
}
